import { Link } from "react-router-dom";
import { FiBriefcase, FiArrowRight } from "react-icons/fi";

/**
 * Estado mostrado quando o backend responde COMPANY_REQUIRED: o usuário está
 * logado, mas ainda não tem empresa cadastrada. É um passo que falta, não um
 * erro — então a tela oferece o caminho em vez de um alerta vermelho.
 */
const CompanyRequiredState = ({
  title = "Falta cadastrar sua empresa",
  description = "Os planos são contratados pela empresa anunciante. Preencha os dados do seu CNPJ para liberar esta área.",
}) => (
  <div className="company-required">
    <span className="company-required__icon">
      <FiBriefcase size={26} />
    </span>
    <h2>{title}</h2>
    <p>{description}</p>
    <Link className="button button--primary" to="/empresa">
      Cadastrar minha empresa
      <FiArrowRight size={16} style={{ marginLeft: 8 }} />
    </Link>
    <span className="company-required__note">
      Você pode cadastrar produtos e anunciar enquanto a verificação do CNPJ está
      em análise.
    </span>
  </div>
);

export default CompanyRequiredState;
